import { createSignatureForContact } from '../../graphql/mutations';
import {
  SET_SIGNATURE_DATA_REQUESTED,
  SET_SIGNATURE_DATA_COMPLETED,
  SET_SIGNATURE_DATA_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

/**
 * Sets client signature
 *
 * @param {string} Signature - Client signature base64 encoded string
 * @param {string=} contactId - Optional contact ID to set signature
 * @param {string=} resourceId - Optional resource ID to allow guests to set sigratures
 * @param {string} [authMode=userPool] - Authentication mode to use for request
 */
const setSignatureForContactAction =
  (Signature, contactId, resourceId, authMode = 'userPool') =>
  async (dispatch, getState) => {
    const { contacts } = getState();
    const { ContactID } = contacts.get('set');

    dispatch({
      type: SET_SIGNATURE_DATA_REQUESTED,
    });

    try {
      await api.graphql({
        authMode,
        query: createSignatureForContact,
        variables: {
          ResourceId: resourceId,
          ContactID: contactId ?? ContactID,
          Signature,
        },
      });

      dispatch({
        type: SET_SIGNATURE_DATA_COMPLETED,
        payload: { Signature },
      });
    } catch (err) {
      debug(SET_SIGNATURE_DATA_FAILED, err);

      dispatch({
        type: SET_SIGNATURE_DATA_FAILED,
        payload: err,
      });
    }
  };

export default setSignatureForContactAction;
